<div class="container">
  <div class="modal-header">
    <h5 class="modal-title">{{ 'map.sidebar.psa.risk_event.title_edit_rel' | translate }}</h5>
  </div>

  <div
    class="modal-body scrollable-container d-flex flex-column align-items-start justify-content-center gap-4 py-3 my-4"
  >
    <b>{{ data.evento.nome }}</b>
    <div class="d-flex align-items-center justify-content-between gap-4 w-100">
      <mat-form-field class="w-100">
        <mat-label>Note</mat-label>
        <textarea
          matInput
          class="w-100"
          [(ngModel)]="note"
          cdkTextareaAutosize
          #autosize="cdkTextareaAutosize"
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="10"
        ></textarea>
      </mat-form-field>
      <div class="d-flex align-items-center gap-2">
        <mat-icon svgIcon="probabilita" [matTooltip]="'Probabilità'"></mat-icon>
        <app-rank-selector
          [valueRank]="probabilita"
          [allowEmpty]="true"
          (rankChange)="probabilita = $event"
        ></app-rank-selector>
      </div>
    </div>
  </div>

  <div class="d-flex align-items-center justify-content-end gap-3">
    <button mat-button type="button" (click)="onCancel()">
      {{ 'map.sidebar.psa.risk_event.button_cancel' | translate }}
    </button>
    <button mat-raised-button color="primary" type="submit" (click)="onSave()">
      {{ 'map.sidebar.psa.risk_event.button_save' | translate }}
    </button>
  </div>
</div>
